module.exports = __webpack_public_path__ + "static/media/Apponboarding720.e7be5d5b.m4v";